import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

import { alertsOptions } from './constants'

const HasAlertsSelector = ({ onChange, value }) => {
  const { t } = useTranslation()

  const handleChange = e => onChange(e.target.value)

  return (
    <div>
      <ComboBox
        value={value}
        label={t('Tiene alertas pendientes')}
        fullWidth
        handleChange={handleChange}
        menuItems={alertsOptions.map(option => ({
          label: t(option.label),
          value: option.value,
        }))}
      />
    </div>
  )
}

export default HasAlertsSelector
